import axios from "axios";

const InitialState = {
    counterSkillConstructor: null,
    counterProgramConstructor: null,
    counterModuleConstructor: null,
    counterExpertConstructor: null
};

const CONSTRUCTOR_INDEX_TYPE = "CONSTRUCTOR_INDEX_TYPE";

function counterSkillConstructorGetRequest() {
    return axios("/work/api/dashboard/counter/constructor-skills", {
        headers: {'Accept': 'application/json'},
    });
}

function counterModuleConstructorGetRequest() {
    return axios("/work/api/dashboard/counter/constructor-modules", {
        headers: {'Accept': 'application/json'},
    });
}

function counterProgramConstructorGetRequest() {
    return axios("/work/api/dashboard/counter/constructor-programs", {
        headers: {'Accept': 'application/json'},
    });
}

function counterExpertiseConstructorGetRequest() {
    return axios("/work/api/dashboard/counter/constructor-expertise", {
        headers: {'Accept': 'application/json'},
    });
}



function counterSkillConstructorReceive(item) {
    return {
        type: CONSTRUCTOR_INDEX_TYPE,
        reduce: (state) => {
            return {
                ...state,
                counterSkillConstructor: item
            }
        }
    }
}

function counterModuleConstructorReceive(item) {
    return {
        type: CONSTRUCTOR_INDEX_TYPE,
        reduce: (state) => {
            return {
                ...state,
                counterModuleConstructor: item
            }
        }
    }
}

function counterProgramConstructorReceive(item) {
    return {
        type: CONSTRUCTOR_INDEX_TYPE,
        reduce: (state) => {
            return {
                ...state,
                counterProgramConstructor: item
            }
        }
    }
}

function counterExpertiseConstructorReceive(item) {
    return {
        type: CONSTRUCTOR_INDEX_TYPE,
        reduce: (state) => {
            return {
                ...state,
                counterExpertiseConstructor: item
            }
        }
    }
}



export function counterSkillConstructorQuery() {
    return (dispatch) => {
        return counterSkillConstructorGetRequest()
            .then(response => {
                dispatch(counterSkillConstructorReceive(response.data))
            }, err => {
                dispatch(counterSkillConstructorReceive(null))
            })
    }
}

export function counterModuleConstructorQuery() {
    return (dispatch) => {
        return counterModuleConstructorGetRequest()
            .then(response => {
                dispatch(counterModuleConstructorReceive(response.data))
            }, err => {
                dispatch(counterModuleConstructorReceive(null))
            })
    }
}

export function counterProgramConstructorQuery() {
    return (dispatch) => {
        return counterProgramConstructorGetRequest()
            .then(response => {
                dispatch(counterProgramConstructorReceive(response.data))
            }, err => {
                dispatch(counterProgramConstructorReceive(null))
            })
    }
}

export function counterExpertiseConstructorQuery() {
    return (dispatch) => {
        return counterExpertiseConstructorGetRequest()
            .then(response => {
                dispatch(counterExpertiseConstructorReceive(response.data))
            }, err => {
                dispatch(counterExpertiseConstructorReceive(null))
            })
    }
}


export function reducer(state = InitialState, action) {
    if (action.type === CONSTRUCTOR_INDEX_TYPE) {
        return action.reduce(state)
    }
    return state;
}
